export const EMAIL = "akalapsazov@yahoo.com";
export const PHONE = "+359888998210";
export const LINKEDIN_URL =
  "https://www.linkedin.com/in/aleksandar-kalapsazov-49014510b/";
